import {backedUrl} from './config';
import {stringify} from 'qs';
import CookieStor from "./CookieStor";

const MAX_REFRESH_TOKEN_REQUEST = 1;
let refreshTokenRequestCount = 0;

class BackendApi {

	/**
	 * @param {string} url
	 * @param {{method?: string, headers?: object, body?: string|object|FormData}} [options]
	 * @return {Promise}
	 */
	static sendRequest(url, options){
		// const self = this;
		options = options || {};
		let method = options.method || 'GET';
		let headers = options.headers || {'Accept': 'application/json'};
		let body = options.body || null;
		let requestUrl = url;

		if(method === 'POST' || body)
		{
			if(!(body instanceof FormData))
			{
				headers['Content-Type'] = 'application/x-www-form-urlencoded';
			}
			method = 'POST';
		}

		if(body && typeof body === 'object' && !(body instanceof FormData))
		{
			body = stringify(body);
		}

		return new Promise((resolve, reject) => {
			fetch(requestUrl, {
				method,
				headers,
				body,
			})
				.then((response) => {
					response.json().then((data) => {
						let resultData = {
							data: data,
							status: response.status,
							statusText: response.statusText
						};

						let pagination = {};
						const xPaginationKeyToVal = {
							'X-Pagination-Current-Page': 'currentPage',
							'X-Pagination-Page-Count': 'pageCount',
							'X-Pagination-Per-Page': 'perPage',
							'X-Pagination-Total-Count': 'totalCount',
						};
						for(let xPaginationKeyToValKey in xPaginationKeyToVal)
						{
							const value = response.headers.get(xPaginationKeyToValKey);
							if(value !== undefined || value !== null)
							{
								pagination[xPaginationKeyToVal[xPaginationKeyToValKey]] = value;
							}
						}
						if(Object.keys(pagination).length)
						{
							resultData.pagination = pagination;
						}

						resolve(resultData);
					})
				})
				.catch((error) => {
					reject(error);
				});
		});
	}

	static async sendRequestWithAuth(url, options){
		let urlWithAuth = url + (url.indexOf('?') !== -1 ? '&':'?') + 'access-token=' + this.getAccessToken();

		const response = await this.sendRequest(urlWithAuth, options);

		if(response.status === 401 && this.getRefreshToken())
		{
			while(refreshTokenRequestCount < MAX_REFRESH_TOKEN_REQUEST)
			{
				++refreshTokenRequestCount;
				if(await this.refreshToken(refreshTokenRequestCount === MAX_REFRESH_TOKEN_REQUEST))
				{
					refreshTokenRequestCount = 0;
					return await this.sendRequestWithAuth(url, options);
				}
			}
		}

		return response;
	}

		
	static async videoList(page){
		let request = {
			'per-page': 12
		};

		if(page) request['page'] = page;

		return await this.sendRequestWithAuth(backedUrl + '/video/?' + stringify(request))
	}
	
	static async videoInfo(slug){
		return await this.sendRequestWithAuth(backedUrl + '/video/' + slug)
	}
	
	static async commentList(slug){
		return await this.sendRequestWithAuth(backedUrl + '/comment/list/' + slug)
	}

	static async getProfile(slug){
		return await this.sendRequestWithAuth(backedUrl + '/user/get-profile/')
	}
	
	static async addComment(slug, comment){
		const response = await this.sendRequestWithAuth(backedUrl + "/comment/add", {
			body: {
				video: slug,
				comment: comment,
			}
		});
		return response
	}
	
	static async auth(authData) {
		const response = await this.sendRequest(backedUrl + "/auth/token-generate", {
			body: {
				login: authData.login,
				password: authData.password,
			}
		});

		const {status, data} = response;

		if(status === 200 && data.access_token)
		{
			this.setAccessToken(data.access_token);
			this.setRefreshToken(data.refresh_token);
		}

		return response
	}

	static async refreshToken(logout){
		try
		{
			const {status, data} = await this.sendRequest(backedUrl + "/auth/token-refresh", {
				body: {
					refresh_token: this.getRefreshToken()
				}
			});

			if(status === 200 && data.access_token)
			{
				this.setAccessToken(data.access_token);
				this.setRefreshToken(data.refresh_token);
				return true;
			}
		}
		catch(e)
		{
		}

		if(logout) this.logout();

		return false;
	}

	static logout(){
		CookieStor.setAccessToken('');
		CookieStor.setRefreshToken('');
		return true;
	}

	static setAccessToken(token){
		CookieStor.setAccessToken(token);
	}

	static setRefreshToken(token){
		CookieStor.setRefreshToken(token);
	}

	static getAccessToken(){
		return CookieStor.getAccessToken();
	}

	static getRefreshToken(){
		return CookieStor.getRefreshToken();
	}

}

export default BackendApi;